import { render, staticRenderFns } from "./salaryPerks.vue?vue&type=template&id=10819216&scoped=true"
import script from "./salaryPerks.vue?vue&type=script&lang=js"
export * from "./salaryPerks.vue?vue&type=script&lang=js"
import style0 from "./salaryPerks.vue?vue&type=style&index=0&id=10819216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10819216",
  null
  
)

export default component.exports